import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from '../components/profile/ChangePasswordModal';
import { ArrowLeftIcon, SettingsIcon } from '../components/Icons';
import styles from './ProfileAccount.module.css';

const ProfileAccount = () => {
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);

  return (
    <div className={styles.accountPage}>
      <header className={styles.topBar}>
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate('/profile')}
        >
          <ArrowLeftIcon size={20} />
          {/* <span>返回</span> */}
        </button>
        <div className={styles.pageTitle}>我的账户</div>
      </header>

      <div className={styles.menuList}>
        <button
          type="button"
          className={styles.menuItem}
          onClick={() => setShowChangePassword(true)}
        >
 
          <div className={styles.menuContent}>
            <div className={styles.menuTitle}>修改密码</div>
            <div className={styles.menuDescription}>更新登录密码，保障账户安全</div>
          </div>
          <div className={styles.menuArrow}>›</div>
        </button>
      </div>

      <ChangePasswordModal
        open={showChangePassword}
        onClose={() => setShowChangePassword(false)}
      />
    </div>
  );
};

export default ProfileAccount;
